<template>
  <!-- <v-col cols="12">
    <h1>黃金計畫會議清單</h1>
  </v-col> -->
  <v-card>
    <v-card-item>
      <v-row class="pt-3 pb-5">
       
        <v-col cols="12" md="2">
          <v-select
            label="年度"
            item-title="1"
            item-value="0"
            v-model="viewParams.meetingFilter.fiscalYear"
            :items="viewParams.fiscalYearSelect" ></v-select>
        </v-col>
        <v-col cols="12" md="2">
          <v-select
            label="會議日期"
            item-title="1"
            item-value="0"
            clearable
            v-model="viewParams.meetingFilter.meetingDate"
            :items="viewParams.meetingDateSelect" ></v-select>
        </v-col>
        <v-col cols="12" md="3">
          <v-text-field label="會議名稱" v-model="viewParams.meetingFilter.meetingName"></v-text-field>
        </v-col>
        <v-col cols="12" md="1"
          ><VBtn
            icon="tabler-search"
            variant="tonal"
            color="secondary"
            @click="search"
        /></v-col>
        <v-col cols="12" md="4" class="d-flex justify-end">
          <v-btn color="primary" @click="dialogParams.open" ><VIcon icon="tabler-plus" class="mr-2"></VIcon>新增</v-btn >
        </v-col>
        <v-data-table
          :headers="headers"
          :items="tbtca21Vos"
          class=""  
          fixed-header 
          items-per-page="-1">
          <!-- height="350px"  -->
          <template v-slot:item.meetingFile="{ item }">
            <VBtn icon="tabler-download" v-if="item.meetingFile" @click.prevent="getJwtBeforeRedirect(item.meetingFile)" href="" variant="outlined" color="primary"  class="ml-2" />
          </template>
          <template v-slot:item.projectExample="{ item }">
            <VBtn icon="tabler-download" v-if="item.projectExample"  @click.prevent="getJwtBeforeRedirect(item.projectExample)" href="" variant="outlined" color="primary" class="ml-2" />
          </template>
          <template v-slot:item.docFile="{ item }">
            <VBtn icon="tabler-download" v-if="item.docFile" @click.prevent="getJwtBeforeRedirect(item.docFile)" href="" variant="outlined" color="primary" class="ml-2" />
          </template>
          <template v-slot:item.actions="{ item }">
            <VBtn icon="tabler-edit"  variant="outlined" color="secondary" @click="dialogParams.openEdit(item)" class="ml-2"/>
            <VBtn icon="tabler-trash" variant="outlined" color="error" @click="deleteMeeting(item.meetingId)" class="ml-2"/>
          </template>
           <!-- <template v-slot:bottom> </template> -->
        </v-data-table>
      </v-row>
    </v-card-item>
  </v-card>

  <v-dialog v-model="dialogParams.isShow" max-width="1000px" no-click-animation persistent>
    <v-card>
      <v-col class="d-flex justify-center mt-5"
        ><h2 class="headline">新增黃金計畫會議記錄</h2></v-col
      >
      <v-card-item>
        <v-form ref="dlgFormRef">
          <v-row>
            <v-col cols="6">
              <div class="text-subtitle-2">經費所屬年度</div>
              <v-select :items="dialogParams.yearSelect" v-model="dialogParams.tbtca21Vo.fiscalYear" ></v-select>
            </v-col>
            <v-col cols="6">
              <div class="text-subtitle-2">會議名稱</div>
              <v-text-field v-model="dialogParams.tbtca21Vo.meetingName" :rules="[rules.required]"></v-text-field>
            </v-col>
          </v-row>

           <v-row>
            <v-col cols="6" >
              <div class="text-subtitle-2">會議日期</div>
              <AppDateTimePicker v-model="dialogParams.tbtca21Vo.meetingDate" placeholder="選擇日期" :rules="[rules.required]"/>
            </v-col>
            <v-col cols="4" >
              <div class="text-subtitle-2">會議記錄</div>
              <VFileInput  v-model="dialogParams.meetingFileArray" @change="uploadFile(dialogParams.meetingFileArray[0],'meetingFile')" />
            </v-col>
            <v-col cols="2" v-if="dialogParams.tbtca21Vo.meetingFile" >
              <div class="text-subtitle-2">已上傳的記錄</div>
              <v-btn  @click.prevent="getJwtBeforeRedirect(dialogParams.tbtca21Vo.meetingFile)">下載</v-btn>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6" >
              <div class="text-subtitle-2">公文號</div>
              <v-text-field v-model="dialogParams.tbtca21Vo.docNo" :rules="[rules.required]"></v-text-field>
            </v-col>
             <v-col cols="4" >
              <div class="text-subtitle-2">公文上傳</div>
              <VFileInput  v-model="dialogParams.docFileArray" @change="uploadFile(dialogParams.docFileArray[0],'docFile')"/>
            </v-col>
            <v-col cols="2" v-if="dialogParams.tbtca21Vo.docFile" >
              <div class="text-subtitle-2">已上傳的公文</div>
              <v-btn @click.prevent="getJwtBeforeRedirect(dialogParams.tbtca21Vo.docFile)" href="">下載</v-btn>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6" >
              <div class="text-subtitle-2">黃金計畫範例</div>
              <VFileInput  v-model="dialogParams.projectExampleArray" @change="uploadFile(dialogParams.projectExampleArray[0],'projectExample')"/>
            </v-col>
            <v-col cols="2" v-if="dialogParams.tbtca21Vo.projectExample" >
              <div class="text-subtitle-2">已上傳的範例</div>
              <v-btn  @click.prevent="getJwtBeforeRedirect(dialogParams.tbtca21Vo.projectExample)" href="">下載</v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-card-item>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="dialogParams.isShow = false">取消</v-btn>
        <v-btn color="blue darken-1" text @click="dialogParams.save">確認儲存</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script  setup lang="ts">
import { reactive } from 'vue';
import { useRouter } from "vue-router"

definePage({
  meta: {
      action: 'manage', //固定為 manage
      subject: 'GOLDPLANMEETINGRECORDS', //系統代碼(系統授權設定中的系統代碼)
  },
});
const router = useRouter()
const fileUrl = useStorage('drFsUrl').value
const dlgFormRef = ref(null);
const rules = ref({
   required: (value: any) => !!value || '此欄位為必填',
});
const validate = async () => {
  const { valid } = await dlgFormRef.value.validate();
  return valid
};
const viewParams = reactive({
  fiscalYearSelect :[],
  meetingDateSelect :[],
  meetingFilter: {
    fiscalYear :'',
    meetingDate :'',
    meetingName: ''
  }
});

// JWT
const getJ = async()=>{
  const { data: jwt, execute: getJwt } = await useApi<any>(createUrl('/tca/file/get', {})) 
  return jwt
}

const getSelect = async () => {
  const apiUrl='/tca/meeting/get/select'
  await $api(apiUrl, {
    method: 'GET'
  }).then((resp) => {
    Object.assign(viewParams.fiscalYearSelect, resp.data.fiscalYearSelect); 
    Object.assign(viewParams.meetingDateSelect, resp.data.meetingDateSelect); 
  })
};

onMounted(() => {
  getSelect();
  viewParams.meetingFilter.fiscalYear = getCurrentRocYear();
  search();
});


const dialogParams = reactive({
  tbtca21Vo: {},
  isShow: false,
  meetingFileArray: '',
  docFileArray: '',
  projectExampleArray: '',
  yearSelect: [],
  open: () =>{
    const currentRocYear = getCurrentRocYear();
    dialogParams.setSelect();
    for (var member in dialogParams.tbtca21Vo) delete dialogParams.tbtca21Vo[member];
    dialogParams.tbtca21Vo.fiscalYear = currentRocYear+'';
    dialogParams.isShow = true;
  },
  openEdit: (item) =>{
    dialogParams.setSelect();
    dialogParams.tbtca21Vo = Object.assign({}, item);
    dialogParams.isShow = true;
  },
  setSelect: () => {
    const currentRocYear = getCurrentRocYear();
    if(dialogParams.yearSelect.length === 0) {
      dialogParams.yearSelect.push(currentRocYear+'');
      dialogParams.yearSelect.push((currentRocYear+1)+'');
      dialogParams.yearSelect.push((currentRocYear+2)+'');
    }
  },
  save: async () =>{
    if(await validate()) {
      add(dialogParams.tbtca21Vo);
      dialogParams.isShow = false;
    }
  },
  goto: (item) => {
    router.push({ path: '/tca/erm/GoldPlanAthleteList', query: {
       meetingId: item.meetingId, 
       fiscalYear: item.fiscalYear,
       meetingDate: item.meetingDate,
       meetingName: item.meetingName
    } })
  }
});


const tbtca21Vos = reactive([]);

const headers = [
  { title: "公文號", key: "docNo", sortable: false },
  { title: "年度", key: "fiscalYear", sortable: false },
  { title: "會議日期", key: "meetingDate", sortable: false },
  { title: "會議名稱", key: "meetingName", sortable: false },
  { title: "黃金計畫範例", key: "projectExample", sortable: false },
  { title: "會議記錄", key: "meetingFile", sortable: false },
  { title: "公文檔案", key: "docFile", sortable: false },
  { title: "操作", key: "actions", sortable: false },
];


const uploadFile =async(file, key)=>{
  const formData = new FormData();
  formData.append('file', file);
  try {
    const response = await $api(`/tca/file/upload`, {
      method: 'POST',
      body: formData,
    });
    dialogParams.tbtca21Vo[key] = response.fileId;
  } catch (error) {
    $swal({
      title: "上傳失敗",
      position: 'top-end',
      text: error.message || "請稍後再試",
      icon: "error"
    });
  }
}


const add = async (tbtca21Vo) => {
  const apiUrl='/tca/meeting/add'
  await $api(apiUrl, {
    method: 'POST',
    body: tbtca21Vo
  }).then((resp) => {
    if (resp.statusCode == 200) {
      popSwal('success','新增成功');
      search();
    } else  {
      popSwal('error','新增失敗,錯誤訊息'+resp.data);
    }
  })
};

const search = async () => {
  tbtca21Vos.length = 0;
  const apiUrl='/tca/meeting/search'
  await $api(apiUrl, {
    method: 'POST',
    body: viewParams.meetingFilter
  }).then((resp) => {
    if (resp.statusCode == 200) {
      Object.assign(tbtca21Vos, resp.data); 
    } else  {
      popSwal('error','搜尋失敗,錯誤訊息'+resp.data);
    }
  })
};

const deleteMeeting = async (meetingId) => {
  const formData = new FormData();
  formData.append('meetingId', meetingId);
  const apiUrl='/tca/meeting/delete'
  await $api(apiUrl, {
    method: 'POST',
    body: formData
  }).then((resp) => {
    if (resp.statusCode == 200) {
      popSwal('success','刪除成功');
      search();
    } else  {
      popSwal('error','刪除失敗,錯誤訊息'+resp.data);
    }
  })
};

const popSwal = (icon,title) => {
  $swal({
    position: 'top-end',
    icon: icon,
    title: title,
    showConfirmButton: false,
    timer: 3000,
    customClass: {
      confirmButton: 'btn btn-primary',
    },
    buttonsStyling: false,
  });
}

const getCurrentRocYear = () => {
  const currentYear = new Date().getFullYear();
  const currentRocYear = currentYear-1911;
  return currentRocYear;
}

// file
const getJwtBeforeRedirect = async (fileId) => {
  const jwt = await getJ();  // 获取新的 JWT
  let generatedUrl = `${fileUrl}/api/v2/files/nstc/${fileId}?drJwt=${jwt.value}`;
  // 打开新链接
  window.open(generatedUrl, '_blank');
};

</script>

<style scoped>
.headline {
  font-weight: bold;
}
</style>
